import { ANCHOR_TAG_NAME, IMG_TAG_NAME, FLUID_URL_QUERY_SELECTOR } from './constants';
import processAnchorElements, { getUrl } from './processAnchorElementsFromHtmlContent';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from 'owa-attachment-link-common';
import { AnchorElementsSource } from 'owa-link-data';
import { trace } from 'owa-trace';
import { BeforePasteEvent, PasteOption } from 'roosterjs-editor-types';
import { isBohemiaEnabledForScenario, BohemiaEnabledScenario } from 'owa-prague-integrations';

export default async function handleBeforePasteEvent(
    event: BeforePasteEvent,
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer,
    linkIdsWithSpinner: string[]
) {
    if (event.pasteOption !== PasteOption.PasteHtml) {
        return;
    }

    trace.info('LinkPlugin.handleBeforePasteEvent');

    // If the fluid framework / bohemia option is enabled,
    // check for the presence of the fluid-url property on the root of the fragment.
    // If it exists, replace it with an anchor tag.
    if (isBohemiaEnabledForScenario(BohemiaEnabledScenario.Compose)) {
        const fluidUrlElement = event.fragment.querySelector(FLUID_URL_QUERY_SELECTOR);
        if (fluidUrlElement) {
            const newAnchor = document.createElement(ANCHOR_TAG_NAME);
            newAnchor.href = fluidUrlElement.getAttribute('fluid-url');
            newAnchor.textContent = newAnchor.href;
            fluidUrlElement.parentNode.replaceChild(newAnchor, fluidUrlElement);
        }
    }

    const links = event.fragment.querySelectorAll(ANCHOR_TAG_NAME);
    const images: NodeListOf<HTMLImageElement> = event.fragment.querySelectorAll(IMG_TAG_NAME);
    const isPureLinks: boolean = isPastedTextPureLinks(event.fragment.textContent, links);
    processAnchorElements(
        links,
        null,
        AnchorElementsSource.PasteHtml,
        linkPlugin,
        linkIdContainer,
        linkIdsWithSpinner,
        true /*shouldChangeLinkId*/,
        isPureLinks && images.length === 0
    );
}

function isPastedTextPureLinks(text: string, allLinks: NodeListOf<HTMLAnchorElement>): boolean {
    const textAfterWhitespaceRemoved: string = text.replace(/\s/g, '');
    let allHrefTogether: string = '';
    for (let i = 0; i < allLinks.length; i++) {
        const link = allLinks[i] as HTMLAnchorElement;
        allHrefTogether += getUrl(link);
    }

    return textAfterWhitespaceRemoved.toLowerCase() === allHrefTogether.toLowerCase();
}
